// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__tbSP5","inputDescription":"styles_inputDescription__1cY8d"};